import React, { useState, useContext, useEffect } from "react";
import TextField from "../../base/textfield";
import { InputAdornment, Typography } from "@mui/material";
import EInfoToolTip from "../eInfo-tooltip";
import UserContext from "../../../services/user/user";
import messages_de from "../../../translations/de.json";
import messages_en from "../../../translations/en.json";
import messages_es from "../../../translations/es.json";
import messages_fr from "../../../translations/fr.json";

import { FormattedMessage } from "react-intl";

export default function ETextField({
  name,
  setValue,
  label,
  initValue = "",
  required = false,
  type = "text",
  disabled = false,
  tooltip = false,
  tooltipMessage,
  startIcon,
  endIcon,
  ...props
}) {
  const messages = {
    de: messages_de,
    en: messages_en,
    es: messages_es,
    fr: messages_fr
  };
  const { lang } = useContext(UserContext);

  const [value, setValueInternal] = useState(initValue);
  const [helperText, setHelperText] = useState("");
  const [inputError, setInputError] = useState(false);

  useEffect(() => {
    setValueInternal(initValue);
  }, [initValue]);

  const errorMessage = `${messages[lang]["enterValid"]} ${messages[lang][label]}`;

  const handleChange = (event) => {
    const newValue = event.target.value;
    let hasError = false;
    if (
      type === "email" &&
      !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(newValue)
    ) {
      hasError = true;
      setHelperText(errorMessage);
    } else if (type === "alphanumeric" && !/^[A-Za-z0-9]*$/.test(newValue)) {
      hasError = true;
      setHelperText(errorMessage);
    } else if (type === "alphabet" && !/^[a-zA-Z ]*$/.test(newValue)) {
      hasError = true;
      setHelperText(errorMessage);
    } else if (
      type === "phone" &&
      !/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d+)\)?)[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i.test(
        newValue
      )
    ) {
      hasError = true;
      setHelperText(errorMessage);
    } else if (required && newValue === "") {
      hasError = true;
      setHelperText(`${messages[lang][label]} ${messages[lang]["isRequired"]}`);
    } else {
      setHelperText("");
    }

    setInputError(hasError);
    setValueInternal(newValue);
    setValue(newValue, name);
  };

  return (
    <>
      <div>
        <label htmlFor={`text-field-${label}`}>
          <Typography
            variant="subtitle2"
            component="span"
            sx={{ opacity: disabled ? 0.6 : 1 }}
          >
            {messages[lang][label] ?? label}
            {required ? "*" : ""}
          </Typography>
        </label>
        {tooltip && (
          <div data-testid="info-tooltip">
            <EInfoToolTip
              msg={
                <ul>
                  <li>
                    <FormattedMessage id={tooltipMessage} />
                  </li>
                </ul>
              }
            />
          </div>
        )}
      </div>
      <TextField
        id={`text-field-${label}`}
        name={name}
        value={value}
        fullWidth
        variant="filled"
        type={type === "password" ? "password" : "text"}
        error={inputError}
        helperText={helperText}
        onChange={handleChange}
        disabled={disabled}
        InputProps={{
          disableUnderline: true,
          startAdornment: startIcon && (
            <InputAdornment position="start">{startIcon}</InputAdornment>
          ),
          endAdornment: endIcon && (
            <InputAdornment position="end">{endIcon}</InputAdornment>
          )
        }}
        sx={{
          ".MuiFilledInput-input": {
            pt: "8px",
            borderRadius: "8px"
          },
          ".MuiInputBase-root": {
            borderRadius: "6px",
            backgroundColor: disabled
              ? "var(--input-disabled-bg) !important"
              : "var(--input-primary-bg)"
          },
          // color: textColor,
          color: "red"
        }}
        {...props}
      />
    </>
  );
}
